import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ModalService } from './modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
})
export class ModalComponent implements OnInit {
  @Input() template: TemplateRef<any> | null;
  showModal: boolean = false;

  constructor(private modalService: ModalService) {}

  ngOnInit() {
    this.modalService.showModal$.subscribe((show) => {
      this.showModal = show;
      this.template = this.modalService.component;
    });
  }

  close() {
    this.modalService.closeModal();
  }
}
